import React, { useState, useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
  Image,
} from "@react-pdf/renderer";
import useOrdersData from "../hooks/useOrdersData";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Button } from "@mui/material";
import { pdf } from "@react-pdf/renderer";
import API_BASE_URL from "../config";
import { Font } from "@react-pdf/renderer";

Font.register({
  family: "DejaVuSans",
  src: "/fonts/DejaVuSans.ttf",
});

Font.register({
  family: "DejaVuSans-Bold",
  src: "/fonts/DejaVuSans-Bold.ttf",
});

const globalStyles = StyleSheet.create({
  title: {
    fontSize: 9,
    fontWeight: "bold",
    fontFamily: "DejaVuSans",
    marginBottom: 5,
  },
  tableCell: {
    width: "25%",
    textAlign: "center",
    fontSize: 9,
    padding: 4,
    fontFamily: "DejaVuSans",
  },
  footerText: {
    fontSize: 8,
    lineHeight: 1.5,
    textAlign: "left",
  },
});

const styles = StyleSheet.create({
  page: { padding: 30, backgroundColor: "#ffffff", position: "relative" },

  header: { flexDirection: "column", alignItems: "flex-start" },

  rightHeader: {
    position: "absolute",
    top: 30,
    left: 410,
    alignItems: "flex-start",
  },

  table: {
    marginTop: 20,
    width: "100%",
    border: "1px solid black",
  },

  tableRow: {
    flexDirection: "row",
  },

  // Fejléc cellák
  tableHeaderCellDenumire: {
    width: "30%",
    textAlign: "center",
    fontSize: 10,
    padding: 5,
    fontFamily: "DejaVuSans-Bold",
    borderRight: "1px solid black",
    borderBottom: "2px solid black",
    backgroundColor: "#e0e0e0",
  },

  tableHeaderCellSmall: {
    width: "11%",
    textAlign: "center",
    fontSize: 10,
    padding: 5,
    fontFamily: "DejaVuSans-Bold",
    borderRight: "1px solid black",
    borderBottom: "2px solid black",
    backgroundColor: "#e0e0e0",
  },

  tableHeaderCellTiny: {
    width: "7%",
    textAlign: "center",
    fontSize: 10,
    padding: 5,
    fontFamily: "DejaVuSans-Bold",
    borderRight: "1px solid black",
    borderBottom: "2px solid black",
    backgroundColor: "#e0e0e0",
  },

  tableHeaderCellLast: {
    width: "16%",
    textAlign: "center",
    fontSize: 10,
    padding: 5,
    fontFamily: "DejaVuSans-Bold",
    borderBottom: "2px solid black",
    backgroundColor: "#e0e0e0",
  },

  // Normál cellák
  tableCellDenumire: {
    width: "30%",
    textAlign: "center",
    fontSize: 9,
    padding: 4,
    fontFamily: "DejaVuSans",
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
  },

  tableCellSmall: {
    width: "11%",
    textAlign: "center",
    fontSize: 9,
    padding: 4,
    fontFamily: "DejaVuSans",
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
  },

  tableCellTiny: {
    width: "7%",
    textAlign: "center",
    fontSize: 9,
    padding: 4,
    fontFamily: "DejaVuSans",
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
  },

  tableCellLast: {
    width: "16%",
    textAlign: "center",
    fontSize: 9,
    padding: 4,
    fontFamily: "DejaVuSans",
    borderBottom: "1px solid black",
  },

  totalRow: {
    backgroundColor: "#ffff99",
    fontWeight: "bold",
  },

  noWrapTiny: {
    width: "7%",
    textAlign: "center",
    fontSize: 8,
    padding: 4,
    fontFamily: "DejaVuSans",
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
  },

  emptySpace: { height: 200, marginTop: 20, marginBottom: 30 },

  bottomText: { position: "absolute", left: 30, bottom: 30, fontSize: 8 },

  title: { fontSize: 9, fontWeight: "bold", marginBottom: 5 },

  underlineText: { textDecoration: "underline" },

  boldUnderlineText: { fontWeight: "bold", textDecoration: "underline" },
});

const MyDocument = ({ orderData, customerData }) => {
  const totalMP = orderData.items
    .reduce((acc, item) => acc + (item.quantityMP || 0), 0)
    .toFixed(4);

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.leftHeader}>
          <Text style={globalStyles.title}>SC MARMOREX TRAFIC STONE SRL</Text>
          <Text style={globalStyles.title}>RO: 29710766</Text>
          <Text style={globalStyles.title}>ORADEA-LES-ARAD</Text>
          <Text style={globalStyles.title}>0259440337</Text>
        </View>

        <View style={styles.rightHeader}>
          <Text style={globalStyles.title}>DATE CLIENT</Text>
          <Text style={globalStyles.title}>
            Nume/Prenume: {customerData ? customerData.name : "N/A"}
          </Text>
          <Text style={globalStyles.title}>
            Data comanda:{" "}
            {orderData
              ? new Date(orderData.createdAt).toLocaleDateString()
              : "N/A"}
          </Text>
          <Text style={globalStyles.title}>
            Nr. telefon: {customerData ? customerData.phone : "N/A"}
          </Text>
          <Text style={globalStyles.title}>
            Adresa de livrare: {orderData.street || "fără livrare"}
          </Text>
        </View>

        <Text
          style={[globalStyles.title, { textAlign: "center", marginTop: 30 }]}
        >
          COMANDA CONTRACT NR. {orderData.orderNumber}
        </Text>

        <View style={styles.table}>
          {/* Fejléc */}
          <View style={styles.tableRow}>
            <Text style={styles.tableHeaderCellDenumire}>DENUMIRE</Text>
            <Text style={styles.tableHeaderCellSmall}>LUNGIME</Text>
            <Text style={styles.tableHeaderCellSmall}>LATIME</Text>
            <Text style={styles.tableHeaderCellSmall}>BUCATI</Text>
            <Text style={styles.tableHeaderCellTiny}>MP</Text>
            <Text style={styles.tableHeaderCellTiny}>ML</Text>
            <Text style={styles.tableHeaderCellTiny}>BUC</Text>
            <Text style={styles.tableHeaderCellLast}>BIZOT</Text>
          </View>

          {/* Dinamikus sorok */}
          {(orderData.items || []).map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCellDenumire}>
                {item.materialName || ""}
              </Text>
              <Text style={styles.tableCellSmall}>{item.length || ""}</Text>
              <Text style={styles.tableCellSmall}>{item.width || ""}</Text>
              <Text style={styles.tableCellSmall}>{item.quantity || ""}</Text>
              <Text style={styles.tableCellTiny}>
                {Number.isInteger(item.quantityMP)
                  ? parseInt(item.quantityMP)
                  : item.quantityMP?.toFixed(4)}
              </Text>
              <Text style={styles.tableCellTiny}>{item.quantityML || ""}</Text>
              <Text style={styles.tableCellTiny}>{item.quantityBUC || ""}</Text>
              <Text style={styles.tableCellLast}>{item.bizot || ""}</Text>
            </View>
          ))}

          {/* Összegző sor */}
          <View style={[styles.tableRow, styles.totalRow]}>
            <Text style={styles.tableCellDenumire}></Text>
            <Text style={styles.tableCellSmall}></Text>
            <Text style={styles.tableCellSmall}></Text>
            <Text style={styles.tableCellSmall} wrap={false}>
              MP TOTAL
            </Text>
            <Text style={styles.tableCellTiny}>{totalMP}</Text>
            <Text style={styles.tableCellTiny}></Text>
            <Text style={styles.tableCellTiny}></Text>
            <Text style={styles.tableCellLast}></Text>
          </View>
        </View>

        <View style={styles.emptySpace}>
          {orderData.drawingData && orderData.drawingData !== "N/A" && (
            <Image
              style={{ width: "100%", height: "100%" }}
              src={orderData.drawingData}
            />
          )}
        </View>

        <View style={styles.bottomText}>
          <Text style={globalStyles.boldUnderlineText}>
            Piesele odata comandate nu se mai schimba,
          </Text>
          <Text style={globalStyles.boldUnderlineText}>
            Mostrele afisate sunt module de piata naturala neimplicand livrare
            identica.
          </Text>
          <Text style={globalStyles.underlineText}>
            Comanda va fi reclamata in maxim 48 ore, reclamatii ulterioare nu se
            primesc.
          </Text>
          <Text style={globalStyles.boldUnderlineText}>
            Fiind modele de piatra naturala pot fi livrate la nuanta si venaturi
            diferite.
          </Text>
          <Text style={globalStyles.underlineText}>
            Pentru neplata sau nelivrarea la termen se vor percepe penalizari de
            1% pe ziua de intarziere.
          </Text>
          <Text style={globalStyles.underlineText}>
            Eventualele litigii se solutioneaza de instantele de la
            Oradea-Bihor, sau prin mediere.
          </Text>
          <Text style={globalStyles.boldUnderlineText}>
            Termen maxim de livrare 10 zile lucratoare
          </Text>
          <Text>
            Sunt de acord fie procesate datele mele personale introduse in
            formularul de inregistrare client conform GDPR, legea 190/2018.
          </Text>
          <Text> </Text>
          <Text style={globalStyles.title}> SEMNATURA CLIENT</Text>
        </View>
      </Page>
    </Document>
  );
};

const GeneratePDF = ({ orderData, customerData }) => {
  if (!orderData || !customerData) return null;

  const handleDownload = async () => {
    try {
      const blob = await pdf(
        <MyDocument orderData={orderData} customerData={customerData} />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `comanda_${orderData.orderNumber || "N/A"}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("❌ PDF generálási hiba:", err);
    }
  };

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<PictureAsPdfIcon />}
      onClick={handleDownload}
      sx={(theme) => ({
        borderColor: theme.palette.mode === "dark" ? "#66bb6a" : "#36993a",
        fontSize: "0.75rem",
        textTransform: "none",
        padding: "2px 8px",
        minWidth: "fit-content",
        color: theme.palette.mode === "dark" ? "#66bb6a" : "#36993a",
        "&:hover": {
          borderColor: theme.palette.mode === "dark" ? "#66bb6a" : "#2d7d32",
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(102, 187, 106, 0.1)"
              : "rgba(54, 153, 58, 0.1)",
        },
      })}
    >
      Descarcă
    </Button>
  );
};

export default GeneratePDF;
